// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"ModalFooter-d0ebd7ee7110407e","modal":"ModalFooter-e31944a822c7c67d","footerPlaceholder":"ModalFooter-129329e405fd3599"};